// extracted by mini-css-extract-plugin
export default {"wrapper":"LocalContactInfo_wrapper__SUhXh","actions":"LocalContactInfo_actions__DQkRZ","btn":"LocalContactInfo_btn__RTe0K"};